export const NAVBAR_HEIGHT = 60
export const SIDEBR_WIDTH = 240
export const SIDEBR_COLLAPSED_WIDTH = 80
export const SIDEBR_TRANSITION = '200ms ease'
export const PAGE_TITLE_HEIGHT = 58
export const PAGE_SEARCH_HEIGHT = 85
